module.exports = __webpack_public_path__ + "media/question1_en.e431fe14.wav";